import { render, staticRenderFns } from "./AttendanceRegister.vue?vue&type=template&id=2c10a489&scoped=true&"
import script from "./AttendanceRegister.vue?vue&type=script&lang=js&"
export * from "./AttendanceRegister.vue?vue&type=script&lang=js&"
import style0 from "./AttendanceRegister.vue?vue&type=style&index=0&id=2c10a489&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c10a489",
  null
  
)

export default component.exports